import type { Feature } from './types';

import { getEnvValue } from '../utils';

const id = getEnvValue('NEXT_PUBLIC_COOKIE_WOW_ID');
const integrityHash = getEnvValue('NEXT_PUBLIC_COOKIE_WOW_INTEGRITY_HASH');

const title = 'Cookie Wow';

const config: Feature<{ id: string; integrityHash: string }> = (() => {
  if (id && integrityHash) {
    return Object.freeze({
      title,
      isEnabled: true,
      id,
      integrityHash,
    });
  }

  return Object.freeze({
    title,
    isEnabled: false,
  });
})();

export default config;
